import _ from 'lodash';
import commaNumber from 'comma-number';
import moment from 'moment';

// amzn.to is Amazon's own shortener; keyed as amazon.com to match the server's getDomain.
const DOMAIN_ALIASES = {
  'amzn.to': 'amazon.com'
};

// Matches a path-scoped merchant key only at a path boundary: 'marksandspencer.com/ca' fires on /ca,
// /ca/, /ca?… and /ca#… but not on root-storefront slugs like /cashmere-…. Use this instead of a bare
// includes() when the host also sells from its root with free-form paths. Mirrored in the server, SSR
// and react getDomain twins.
const hasPathKey = (url, key) => {
  const index = url.indexOf(key);
  if (index === -1) return false;
  const next = url[index + key.length];
  return next === undefined || next === '/' || next === '?' || next === '#';
};

export const getDomain = unsanitized_url => {
  let domain = _.first(_.last(_.split(unsanitized_url, '://')).split('/'))
    .split('www.')
    .join('');
  domain = DOMAIN_ALIASES[domain] || domain;

  // Only the hotel entries match against this lowercased copy — hotel sites link their own paths in
  // Title-Case (e.g. caperesorts.com/Pridwin). All other entries match the raw URL case-sensitively,
  // since lowercasing bare country codes would false-match ordinary paths (saucony.com/cart -> /CA).
  const lowercased_url = unsanitized_url.toLowerCase();

  // Handle edge cases, more specific substring checks per domain first to avoid conflicts
  if (unsanitized_url.includes('allbeauty.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('allbeauty.com/us')) domain += '/us';
  else if (unsanitized_url.includes('beautypie.com/us')) domain += '/us';
  else if (unsanitized_url.includes('rodial.com/us')) domain += '/us';
  else if (unsanitized_url.includes('spacenk.com/us')) domain += '/us';
  else if (unsanitized_url.includes('spacenk.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('spacenk.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('spacenk.com/global')) domain += '/global';
  else if (unsanitized_url.includes('spacenk.com/ie')) domain += '/ie';
  else if (unsanitized_url.includes('charlottetilbury.com/ie')) domain += '/ie';
  else if (unsanitized_url.includes('charlottetilbury.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('charlottetilbury.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('charlottetilbury.com/eu')) domain += '/eu';
  else if (unsanitized_url.includes('charlottetilbury.com/de')) domain += '/de';
  else if (unsanitized_url.includes('charlottetilbury.com/nl')) domain += '/nl';
  else if (unsanitized_url.includes('charlottetilbury.com/it')) domain += '/it';
  else if (unsanitized_url.includes('charlottetilbury.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('charlottetilbury.com/us')) domain += '/us';
  else if (unsanitized_url.includes('charlottetilbury.com/au')) domain += '/au';
  else if (unsanitized_url.includes('charlottetilbury.com/es')) domain += '/es';
  else if (unsanitized_url.includes('theordinary.com/en-nz')) domain += '/en-nz';
  else if (unsanitized_url.includes('deciem.com/en-nz')) domain += '/en-nz';
  else if (unsanitized_url.includes('theordinary.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('theordinary.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('theordinary.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('theordinary.com/en-mx')) domain += '/en-mx';
  else if (unsanitized_url.includes('niod.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('niod.com/en-nz')) domain += '/en-nz';
  else if (unsanitized_url.includes('niod.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('niod.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('niod.com/en-mx')) domain += '/en-mx';
  else if (unsanitized_url.includes('deciem.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('libertylondon.com/us')) domain += '/us';
  else if (unsanitized_url.includes('net-a-porter.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('net-a-porter.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('net-a-porter.com/en-pt')) domain += '/en-pt';
  else if (unsanitized_url.includes('net-a-porter.com/en-es')) domain += '/en-es';
  else if (unsanitized_url.includes('net-a-porter.com/en-it')) domain += '/en-it';
  else if (unsanitized_url.includes('net-a-porter.com/en-fr')) domain += '/en-fr';
  else if (unsanitized_url.includes('net-a-porter.com/en-de')) domain += '/en-de';
  else if (unsanitized_url.includes('net-a-porter.com/en-be')) domain += '/en-be';
  else if (unsanitized_url.includes('net-a-porter.com/en-at')) domain += '/en-at';
  else if (unsanitized_url.includes('net-a-porter.com/en-dk')) domain += '/en-dk';
  else if (unsanitized_url.includes('net-a-porter.com/en-fi')) domain += '/en-fi';
  else if (unsanitized_url.includes('net-a-porter.com/en-gr')) domain += '/en-gr';
  else if (unsanitized_url.includes('net-a-porter.com/en-ie')) domain += '/en-ie';
  else if (unsanitized_url.includes('net-a-porter.com/en-nl')) domain += '/en-nl';
  else if (unsanitized_url.includes('net-a-porter.com/en-no')) domain += '/en-no';
  else if (unsanitized_url.includes('net-a-porter.com/en-se')) domain += '/en-se';
  else if (unsanitized_url.includes('net-a-porter.com/en-ch')) domain += '/en-ch';
  else if (unsanitized_url.includes('cos.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('cos.com/en-de')) domain += '/en-de';
  else if (unsanitized_url.includes('cos.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('cos.com/en-ww')) domain += '/en-ww';
  else if (unsanitized_url.includes('cos.com/en-eu-e')) domain += '/en-eu-e';
  else if (unsanitized_url.includes('cos.com/en-eu')) domain += '/en-eu';
  else if (unsanitized_url.includes('cos.com/pl-pl')) domain += '/pl-pl';
  else if (unsanitized_url.includes('cos.com/es-es')) domain += '/es-es';
  else if (unsanitized_url.includes('cos.com/it-it')) domain += '/it-it';
  else if (unsanitized_url.includes('cos.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('cos.com/en-sg')) domain += '/en-sg';
  else if (unsanitized_url.includes('cos.com/en-my')) domain += '/en-my';
  else if (unsanitized_url.includes('cos.com/en-hk')) domain += '/en-hk';
  else if (unsanitized_url.includes('cos.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('cos.com/de-at')) domain += '/de-at';
  else if (unsanitized_url.includes('cos.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('cos.com/zh-tw')) domain += '/zh-tw';
  else if (unsanitized_url.includes('fresh.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('harveynichols.com/int')) domain += '/int';
  else if (unsanitized_url.includes('italist.com/us')) domain += '/us';
  else if (unsanitized_url.includes('ae.com/us/en/c/aerie')) domain += '/us/en/c/aerie';
  else if (unsanitized_url.includes('ae.com/us/en/p/aerie')) domain += '/us/en/p/aerie';
  else if (unsanitized_url.includes('ae.com/us/en/p/ae/aerie')) domain += '/us/en/p/ae/aerie';
  else if (unsanitized_url.includes('ae.com/us/en/c/ae/aerie')) domain += '/us/en/c/ae/aerie';
  else if (unsanitized_url.includes('ugg.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('stradivarius.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('stradivarius.com/us')) domain += '/us';
  else if (unsanitized_url.includes('stradivarius.com/dk')) domain += '/dk';
  else if (unsanitized_url.includes('harrods.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('harrods.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('mrporter.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('mrporter.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('mrporter.com/en-de')) domain += '/en-de';
  else if (unsanitized_url.includes('mrporter.com/en-hk')) domain += '/en-hk';
  else if (unsanitized_url.includes('mrporter.com/en-sg')) domain += '/en-sg';
  else if (unsanitized_url.includes('mrporter.com/ja-jp')) domain += '/ja-jp';
  else if (unsanitized_url.includes('mrporter.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('mrporter.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('shop.mango.com/us')) domain += '/us';
  else if (unsanitized_url.includes('shop.mango.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('shop.mango.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('calzedonia.com/us')) domain += '/us';
  else if (unsanitized_url.includes('sephora.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('dior.com/en_us/beauty')) domain += '/en_us/beauty';
  else if (unsanitized_url.includes('dior.com/en_gb/beauty')) domain += '/en_gb/beauty';
  else if (unsanitized_url.includes('dior.com/en_au/beauty')) domain += '/en_au/beauty';
  else if (unsanitized_url.includes('reiss.com/fr/fr')) domain += '/fr/fr';
  else if (unsanitized_url.includes('reiss.com/nl/en')) domain += '/nl/en';
  else if (unsanitized_url.includes('reiss.com/ie/en')) domain += '/ie/en';
  else if (unsanitized_url.includes('reiss.com/au/en')) domain += '/au/en';
  else if (unsanitized_url.includes('reiss.com/us/en')) domain += '/us/en';
  else if (unsanitized_url.includes('reiss.com/de/de')) domain += '/de/de';
  else if (unsanitized_url.includes('anthropologie.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('anthropologie.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('hudabeauty.com/us/en_US')) domain += '/us/en_US';
  else if (unsanitized_url.includes('hudabeauty.com/dt/en_ES')) domain += '/dt/en_ES';
  else if (unsanitized_url.includes('hudabeauty.com/dt/en_FR')) domain += '/dt/en_FR';
  else if (unsanitized_url.includes('hudabeauty.com/dt/en_IT')) domain += '/dt/en_IT';
  else if (unsanitized_url.includes('hudabeauty.com/dt/en_PL')) domain += '/dt/en_PL';
  else if (unsanitized_url.includes('hudabeauty.com/en_IN')) domain += '/en_IN';
  else if (unsanitized_url.includes('hudabeauty.com/en_AU')) domain += '/en_AU';
  else if (unsanitized_url.includes('hudabeauty.com/ar_SA')) domain += '/ar_SA';
  else if (unsanitized_url.includes('hudabeauty.com/en_CA')) domain += '/en_CA';
  else if (unsanitized_url.includes('hudabeauty.com/en_KW')) domain += '/en_KW';
  else if (unsanitized_url.includes('hudabeauty.com/en_AE')) domain += '/en_AE';
  else if (unsanitized_url.includes('hudabeauty.com/dt/en_DE')) domain += '/dt/en_DE';
  else if (unsanitized_url.includes('shop.lululemon.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('meandem.com/us')) domain += '/us';
  else if (unsanitized_url.includes('uniqlo.com/us')) domain += '/us';
  else if (unsanitized_url.includes('uniqlo.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('roddandgunn.com/us')) domain += '/us';
  else if (unsanitized_url.includes('roddandgunn.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('roddandgunn.com/au')) domain += '/au';
  else if (unsanitized_url.includes('roddandgunn.com/nz')) domain += '/nz';
  else if (unsanitized_url.includes('aldoshoes.com/us')) domain += '/us';
  else if (unsanitized_url.includes('aldoshoes.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('freepeople.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('freepeople.com/france')) domain += '/france';
  else if (unsanitized_url.includes('toryburch.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('toryburch.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('toryburch.com/it-it')) domain += '/it-it';
  else if (unsanitized_url.includes('toryburch.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('toryburch.com/en-eu')) domain += '/en-eu';
  else if (unsanitized_url.includes('armani.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('armani.com/en-nl')) domain += '/en-nl';
  else if (unsanitized_url.includes('armani.com/es-es')) domain += '/es-es';
  else if (unsanitized_url.includes('armani.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('armani.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('armani.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('armani.com/it-it')) domain += '/it-it';
  // en-fr folds into fr-fr: same French Partnerize program
  else if (unsanitized_url.includes('armani.com/en-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('arket.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('ruggable.com/en-CA')) domain += '/en-CA';
  else if (unsanitized_url.includes('stories.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('stories.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('nike.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('allsaints.com/us')) domain += '/us';
  else if (unsanitized_url.includes('allsaints.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('allsaints.com/eu')) domain += '/eu';
  else if (unsanitized_url.includes('urbanoutfitters.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('urbanoutfitters.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('guess.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('barrie.com/en')) domain += '/en';
  else if (unsanitized_url.includes('noblepanacea.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('noblepanacea.com/en-eu')) domain += '/en-eu';
  else if (unsanitized_url.includes('chewy.com/g/shelter-partners')) domain += '/g/shelter-partners';
  else if (unsanitized_url.includes('chewy.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('dolcegabbana.com/it-it')) domain += '/it-it';
  else if (unsanitized_url.includes('dolcegabbana.com/es-es')) domain += '/es-es';
  else if (unsanitized_url.includes('dolcegabbana.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('dolcegabbana.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('dolcegabbana.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('dolcegabbana.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('furla.com/gb/en')) domain += '/gb/en';
  else if (unsanitized_url.includes('furla.com/us/en')) domain += '/us/en';
  else if (unsanitized_url.includes('intimissimi.com/us')) domain += '/us';
  else if (unsanitized_url.includes('chanel.com/us')) domain += '/us';
  else if (unsanitized_url.includes('levi.com/US')) domain += '/US';
  else if (unsanitized_url.includes('levi.com/GB')) domain += '/GB';
  else if (unsanitized_url.includes('levi.com/CA')) domain += '/CA';
  else if (unsanitized_url.includes('abercrombie.com/shop/eu')) domain += '/shop/eu';
  else if (unsanitized_url.includes('abercrombie.com/shop/uk')) domain += '/shop/uk';
  else if (unsanitized_url.includes('penhaligons.com/us')) domain += '/us';
  else if (unsanitized_url.includes('penhaligons.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('penhaligons.com/de')) domain += '/de';
  else if (unsanitized_url.includes('penhaligons.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('artisanparfumeur.com/us')) domain += '/us';
  else if (unsanitized_url.includes('artisanparfumeur.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('artisanparfumeur.com/eu')) domain += '/eu';
  else if (unsanitized_url.includes('artisanparfumeur.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('hogan.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('hogan.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('hogan.com/it-it')) domain += '/it-it';
  else if (unsanitized_url.includes('hogan.com/es-es')) domain += '/es-es';
  else if (unsanitized_url.includes('hogan.com/be-fr')) domain += '/be-fr';
  else if (unsanitized_url.includes('hogan.com/gb-en')) domain += '/gb-en';
  else if (unsanitized_url.includes('hogan.com/us-en')) domain += '/us-en';
  else if (unsanitized_url.includes('belstaff.com/us')) domain += '/us';
  else if (unsanitized_url.includes('belstaff.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('prada.com/us')) domain += '/us';
  else if (unsanitized_url.includes('prada.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('prada.com/it')) domain += '/it';
  else if (unsanitized_url.includes('prada.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('prada.com/de')) domain += '/de';
  else if (unsanitized_url.includes('miumiu.com/us')) domain += '/us';
  else if (unsanitized_url.includes('miumiu.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('miumiu.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('miumiu.com/it')) domain += '/it';
  else if (unsanitized_url.includes('miumiu.com/de')) domain += '/de';
  else if (unsanitized_url.includes('charlestyrwhitt.com/us')) domain += '/us';
  else if (unsanitized_url.includes('suitsupply.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('suitsupply.com/en-nl')) domain += '/en-nl';
  else if (unsanitized_url.includes('suitsupply.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('suitsupply.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('naturabisse.com/us')) domain += '/us';
  else if (unsanitized_url.includes('naturabisse.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('naturabisse.com/mx')) domain += '/mx';
  else if (unsanitized_url.includes('naturabisse.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('naturabisse.com/es')) domain += '/es';
  else if (unsanitized_url.includes('naturabisse.com/it')) domain += '/it';
  else if (unsanitized_url.includes('maisonmargiela.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('maisonmargiela.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('maisonmargiela.com/it-it')) domain += '/it-it';
  else if (unsanitized_url.includes('maisonmargiela.com/wx')) domain += '/wx';
  else if (unsanitized_url.includes('maisonmargiela.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('maisonmargiela.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('maisonmargiela.com/ja-jp')) domain += '/ja-jp';
  else if (unsanitized_url.includes('marcjacobs.com/us-en/the-marc-jacobs/beauty-fragrance')) domain += '/us-en/the-marc-jacobs/beauty-fragrance';
  else if (unsanitized_url.includes('marcjacobs.com/gb-en/the-marc-jacobs/beauty')) domain += '/gb-en/the-marc-jacobs/beauty';
  else if (unsanitized_url.includes('charleskeith.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('charleskeith.com/au')) domain += '/au';
  else if (unsanitized_url.includes('theoutnet.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('theoutnet.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('theoutnet.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('theoutnet.com/en-hk')) domain += '/en-hk';
  else if (unsanitized_url.includes('theoutnet.com/en-sg')) domain += '/en-sg';
  else if (unsanitized_url.includes('theoutnet.com/ja-jp')) domain += '/ja-jp';
  else if (unsanitized_url.includes('theoutnet.com/en-ae')) domain += '/en-ae';
  else if (unsanitized_url.includes('scanlantheodore.com/au')) domain += '/au';
  else if (unsanitized_url.includes('scanlantheodore.com/us')) domain += '/us';
  else if (unsanitized_url.includes('scanlantheodore.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('niche-beauty.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('niche-beauty.com/nl-nl')) domain += '/nl-nl';
  else if (unsanitized_url.includes('niche-beauty.com/es-es')) domain += '/es-es';
  else if (unsanitized_url.includes('amiparis.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('amiparis.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('amiparis.com/en-nl')) domain += '/en-nl';
  else if (unsanitized_url.includes('amiparis.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('amiparis.com/en-it')) domain += '/en-it';
  else if (unsanitized_url.includes('urlgeni.us/amazon')) domain += '/amazon';
  else if (unsanitized_url.includes('urlgeni.us/amzn')) domain += '/amzn';
  else if (unsanitized_url.includes('vrbo.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('vrbo.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('vrbo.com/it-it')) domain += '/it-it';
  else if (unsanitized_url.includes('vrbo.com/nl-nl')) domain += '/nl-nl';
  else if (unsanitized_url.includes('vrbo.com/sv-se')) domain += '/sv-se';
  else if (unsanitized_url.includes('vrbo.com/pt-pt')) domain += '/pt-pt';
  else if (unsanitized_url.includes('vrbo.com/es-es')) domain += '/es-es';
  else if (unsanitized_url.includes('gucci.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('gucci.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('gucci.com/us')) domain += '/us';
  else if (unsanitized_url.includes('gucci.com/mx')) domain += '/mx';
  else if (unsanitized_url.includes('toms.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('toms.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('toms.com/nl-nl')) domain += '/nl-nl';
  else if (unsanitized_url.includes('toms.com/fr-lu')) domain += '/fr-lu';
  else if (unsanitized_url.includes('toms.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('toms.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('toms.com/nl-be')) domain += '/nl-be';
  else if (unsanitized_url.includes('saucony.com/CA')) domain += '/CA';
  else if (unsanitized_url.includes('saucony.com/FR')) domain += '/FR';
  else if (unsanitized_url.includes('saucony.com/UK')) domain += '/UK';
  else if (unsanitized_url.includes('saucony.com/IT')) domain += '/IT';
  else if (unsanitized_url.includes('saucony.com/DE')) domain += '/DE';
  else if (unsanitized_url.includes('massimodutti.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('massimodutti.com/it')) domain += '/it';
  else if (unsanitized_url.includes('massimodutti.com/dk')) domain += '/dk';
  else if (unsanitized_url.includes('massimodutti.com/de')) domain += '/de';
  else if (unsanitized_url.includes('massimodutti.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('massimodutti.com/mx')) domain += '/mx';
  else if (unsanitized_url.includes('massimodutti.com/nl')) domain += '/nl';
  else if (unsanitized_url.includes('massimodutti.com/pl')) domain += '/pl';
  else if (unsanitized_url.includes('massimodutti.com/pt')) domain += '/pt';
  else if (unsanitized_url.includes('massimodutti.com/tr')) domain += '/tr';
  else if (unsanitized_url.includes('rogervivier.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('rogervivier.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('rogervivier.com/gb-en')) domain += '/gb-en';
  else if (unsanitized_url.includes('merrell.com/FR')) domain += '/FR';
  else if (unsanitized_url.includes('merrell.com/UK')) domain += '/UK';
  else if (unsanitized_url.includes('merrell.com/DE')) domain += '/DE';
  else if (unsanitized_url.includes('sweatybetty.com/eu')) domain += '/eu';
  else if (unsanitized_url.includes('rogervivier.com/us-en')) domain += '/us-en';
  else if (unsanitized_url.includes('aldoshoes.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('chloe.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('chloe.com/ja-jp')) domain += '/ja-jp';
  else if (unsanitized_url.includes('chloe.com/ko-kr')) domain += '/ko-kr';
  else if (unsanitized_url.includes('chloe.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('chloe.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('castlery.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('castlery.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('pullandbear.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('pullandbear.com/it')) domain += '/it';
  else if (unsanitized_url.includes('pullandbear.com/de')) domain += '/de';
  else if (unsanitized_url.includes('pullandbear.com/nl')) domain += '/nl';
  else if (unsanitized_url.includes('pullandbear.com/pt')) domain += '/pt';
  else if (unsanitized_url.includes('pullandbear.com/tr')) domain += '/tr';
  else if (unsanitized_url.includes('pullandbear.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('hollisterco.com/shop/uk')) domain += '/shop/uk';
  else if (unsanitized_url.includes('givenchybeauty.com/gb')) domain += '/gb';
  else if (unsanitized_url.includes('adanola.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('adanola.com/en-eu')) domain += '/en-eu';
  else if (unsanitized_url.includes('adanola.com/en-dk')) domain += '/en-dk';
  else if (unsanitized_url.includes('adanola.com/en-ch')) domain += '/en-ch';
  else if (unsanitized_url.includes('adanola.com/en-se')) domain += '/en-se';
  else if (unsanitized_url.includes('adanola.com/en-no')) domain += '/en-no';
  else if (unsanitized_url.includes('adanola.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('adanola.com/en-au')) domain += '/en-au';
  else if (unsanitized_url.includes('adanola.com/en-fr')) domain += '/en-fr';
  else if (unsanitized_url.includes('adanola.com/fr-fr')) domain += '/fr-fr';
  else if (unsanitized_url.includes('zara.com/us')) domain += '/us';
  else if (unsanitized_url.includes('zara.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('zara.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('zara.com/it')) domain += '/it';
  else if (unsanitized_url.includes('zara.com/de')) domain += '/de';
  else if (unsanitized_url.includes('zara.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('zara.com/nl')) domain += '/nl';
  else if (unsanitized_url.includes('zara.com/au')) domain += '/au';
  else if (unsanitized_url.includes('jimmychoo.com/en')) domain += '/en';
  else if (unsanitized_url.includes('sisley-paris.com/en-US')) domain += '/en-US';
  else if (unsanitized_url.includes('sisley-paris.com/fr-FR')) domain += '/fr-FR';
  else if (unsanitized_url.includes('sisley-paris.com/en-GB')) domain += '/en-GB';
  else if (unsanitized_url.includes('sisley-paris.com/es-ES')) domain += '/es-ES';
  else if (unsanitized_url.includes('sisley-paris.com/it-IT')) domain += '/it-IT';
  else if (unsanitized_url.includes('sisley-paris.com/de-DE')) domain += '/de-DE';
  else if (unsanitized_url.includes('sisley-paris.com/fr-BE')) domain += '/fr-BE';
  else if (unsanitized_url.includes('sisley-paris.com/nl-BE')) domain += '/nl-BE';
  else if (unsanitized_url.includes('sisley-paris.com/fr-CH')) domain += '/fr-CH';
  else if (unsanitized_url.includes('sisley-paris.com/de-CH')) domain += '/de-CH';
  else if (unsanitized_url.includes('sisley-paris.com/pl-PL')) domain += '/pl-PL';
  else if (unsanitized_url.includes('sisley-paris.com/pt-PT')) domain += '/pt-PT';
  else if (unsanitized_url.includes('sisley-paris.com/nl-NL')) domain += '/nl-NL';
  else if (unsanitized_url.includes('sisley-paris.com/de-AT')) domain += '/de-AT';
  else if (unsanitized_url.includes('sisley-paris.com/sv-SE')) domain += '/sv-SE';
  else if (unsanitized_url.includes('sisley-paris.com/en-AU')) domain += '/en-AU';
  else if (unsanitized_url.includes('pomellato.com/us_en')) domain += '/us_en';
  else if (unsanitized_url.includes('pomellato.com/de_de')) domain += '/de_de';
  else if (unsanitized_url.includes('pomellato.com/fr_fr')) domain += '/fr_fr';
  else if (unsanitized_url.includes('pomellato.com/it_it')) domain += '/it_it';
  else if (unsanitized_url.includes('pomellato.com/gb_en')) domain += '/gb_en';
  else if (unsanitized_url.includes('loccitane.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('ray-ban.com/usa')) domain += '/usa';
  else if (unsanitized_url.includes('ray-ban.com/australia')) domain += '/australia';
  else if (unsanitized_url.includes('ray-ban.com/brazil')) domain += '/brazil';
  else if (unsanitized_url.includes('sunglasshut.com/us')) domain += '/us';
  else if (unsanitized_url.includes('sunglasshut.com/au')) domain += '/au';
  else if (unsanitized_url.includes('sunglasshut.com/br')) domain += '/br';
  else if (unsanitized_url.includes('yoox.com/it')) domain += '/it';
  else if (unsanitized_url.includes('yoox.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('yoox.com/de')) domain += '/de';
  else if (unsanitized_url.includes('yoox.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('yoox.com/es')) domain += '/es';
  else if (unsanitized_url.includes('ba-sh.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('salomon.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('salomon.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('violetgrey.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('michaelkors.com/outlet')) domain += '/outlet';
  else if (unsanitized_url.includes('michaelkors.com/ca/en/outlet')) domain += '/ca/en/outlet';
  else if (unsanitized_url.includes('michaelkors.com/ca/en')) domain += '/ca/en';
  else if (unsanitized_url.includes('hugoboss.com/de')) domain += '/de';
  else if (unsanitized_url.includes('hugoboss.com/uk')) domain += '/uk';
  else if (unsanitized_url.includes('hugoboss.com/fr')) domain += '/fr';
  else if (unsanitized_url.includes('hugoboss.com/au')) domain += '/au';
  else if (unsanitized_url.includes('birkenstock.com/us')) domain += '/us';
  else if (unsanitized_url.includes('birkenstock.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('benefitcosmetics.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('maxicosi.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('vilebrequin.com/eu')) domain += '/eu';
  else if (unsanitized_url.includes('marksandspencer.com/us')) domain += '/us';
  else if (unsanitized_url.includes('marksandspencer.com/ie')) domain += '/ie';
  else if (hasPathKey(unsanitized_url, 'marksandspencer.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('mlb.com/yankees')) domain += '/yankees';
  else if (unsanitized_url.includes('bamford.com/us')) domain += '/us';
  else if (unsanitized_url.includes('roots.com/ca')) domain += '/ca';
  else if (unsanitized_url.includes('ticketmaster.com/brooklyn-nets-tickets')) domain += '/brooklyn-nets-tickets';
  else if (unsanitized_url.includes('vistaexpert.it/de')) domain += '/de';
  else if (unsanitized_url.includes('vistaexpert.it/fr')) domain += '/fr';
  else if (unsanitized_url.includes('vistaexpert.it/en')) domain += '/en';
  else if (unsanitized_url.includes('santonishoes.com/de-de')) domain += '/de-de';
  else if (unsanitized_url.includes('santonishoes.com/it-it')) domain += '/it-it';
  else if (unsanitized_url.includes('santonishoes.com/us-en')) domain += '/us-en';
  else if (unsanitized_url.includes('ekster.com/en-gb')) domain += '/en-gb';
  else if (unsanitized_url.includes('www2.hm.com/en_us')) domain += '/en_us';
  else if (unsanitized_url.includes('www2.hm.com/en_ca')) domain += '/en_ca';
  else if (unsanitized_url.includes('www2.hm.com/en_gb')) domain += '/en_gb';
  else if (unsanitized_url.includes('www2.hm.com/en_au')) domain += '/en_au';
  else if (unsanitized_url.includes('www2.hm.com/es_mx')) domain += '/es_mx';
  else if (unsanitized_url.includes('ams.diptyqueparis.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('coach.com/shop/outlet')) domain += '/shop/outlet';
  else if (unsanitized_url.includes('fossil.com/en-us')) domain += '/en-us';
  else if (unsanitized_url.includes('fossil.com/en-ca')) domain += '/en-ca';
  else if (unsanitized_url.includes('cottonon.com/UK')) domain += '/UK';
  else if (hasPathKey(unsanitized_url, 'goldengoose.com/de')) domain += '/de';
  else if (hasPathKey(unsanitized_url, 'goldengoose.com/es')) domain += '/es';
  else if (hasPathKey(unsanitized_url, 'goldengoose.com/fr')) domain += '/fr';
  else if (hasPathKey(unsanitized_url, 'goldengoose.com/it')) domain += '/it';
  else if (hasPathKey(unsanitized_url, 'goldengoose.com/gb')) domain += '/gb';
  else if (hasPathKey(unsanitized_url, 'goldengoose.com/us')) domain += '/us';
  // Hotels on shared root domains: each property path is its own brand
  else if (lowercased_url.includes('auberge.com/the-dunlin')) domain += '/the-dunlin';
  else if (lowercased_url.includes('auberge.com/wildflower-farms')) domain += '/wildflower-farms';
  else if (lowercased_url.includes('aubergeresorts.com/the-dunlin')) domain += '/the-dunlin';
  else if (lowercased_url.includes('aubergeresorts.com/wildflower-farms')) domain += '/wildflower-farms';
  else if (lowercased_url.includes('caperesorts.com/pridwin')) domain += '/pridwin';
  else if (lowercased_url.includes('caperesorts.com/congress-hall')) domain += '/congress-hall';
  else if (lowercased_url.includes('caperesorts.com/beach-plum-farm')) domain += '/beach-plum-farm';
  else if (lowercased_url.includes('1hotels.com/south-beach')) domain += '/south-beach';

  return domain;
};

export const prettyNumber = number =>
  Math.abs(number) > 999 ? Math.sign(number) * (Math.abs(number) / 1000).toFixed(1) + 'k' : Math.sign(number) * Math.abs(number);

export const formatAmountInCurrency = (amount, currency) =>
  new Intl.NumberFormat('EN', { style: 'currency', currency: currency || 'USD' }).format(Number(amount) || 0);

export const getPrettyNumber = (numberRaw, options = {}) => {
  /*  
    Shorten the number with standard endings.
    
    1000000 => 1m
    124000 => 124k
    12500 => 12.5k
    1149 => 1.1k
    839 => 839
  */
  const { useAbsolute } = options;
  let number = useAbsolute ? Math.abs(numberRaw) : numberRaw;
  if (number > 1e6) {
    let millions = Math.floor(number / 1e6);
    let hundredthousands = Math.round((number % 1e6) / 1e5);
    if (hundredthousands === 10) {
      millions += 1;
      hundredthousands = 0;
    }
    return millions >= 100 ? `${millions}m` : `${millions}${hundredthousands ? `.${hundredthousands}` : ''}m`;
  } else if (number > 1e3) {
    let thousands = Math.floor(number / 1e3);
    let hundreds = Math.round((number % 1e3) / 1e2);
    if (hundreds === 10) {
      thousands += 1;
      hundreds = 0;
    }
    return thousands >= 100 ? `${thousands}k` : `${thousands}${hundreds ? `.${hundreds}` : ''}k`;
  }
  return number.toFixed(0);
};

export const getPrettyPriceDisplay = (priceRaw, options = {}) => {
  /*
    1.5 => $1.50
    2 => $2
  */
  const { perDay, precision, useUSD, useAbsolute } = options;
  if (!priceRaw && priceRaw !== 0) return '';
  const price = parseFloat(useAbsolute ? Math.abs(priceRaw) : priceRaw);
  const prettyNumber = commaNumber(price.toFixed(!_.isNil(precision) ? precision : price === Math.floor(price) ? 0 : 2));
  return `${useUSD ? '' : '$'}${prettyNumber}${useUSD ? ' USD' : ''}${perDay ? ' per day' : ''}`;
};

export const getPercentileNumber = number => {
  number = Number.parseInt(number) || 0;
  const last_digit_of_number = number % 10;

  switch (last_digit_of_number) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};

// Pluralize a count phrase: "3 days" / "1 day". Pass `plural` only
// when irregular (e.g. "person"/"people"). The count is included in
// the output — for word-only pluralization, do `n === 1 ? 'day' : 'days'`
// inline.
export const pluralizeCount = (n, singular, plural) => `${n} ${n === 1 ? singular : plural || `${singular}s`}`;

// How long ago a time was, in whole hours under a day and whole days after: "under an hour" / "6 hours" / "2 days".
// Use for: how long something has waited, where minutes don't matter. Don't use for: "3 days ago" — use moment(time).fromNow().
export const getPrettyHoursOrDaysSince = (time, now = moment()) => {
  const hours = Math.max(0, moment(now).diff(moment(time), 'hours'));
  if (hours < 1) return 'under an hour';
  return hours < 24 ? pluralizeCount(hours, 'hour') : pluralizeCount(Math.floor(hours / 24), 'day');
};

export const getServerFormattedDate = (dateString = '') => moment(dateString || new Date()).format('YYYY-MM-DD HH:mm:ss');
export const getGMTTime = () => new Date(new Date().toGMTString()).getTime();

// Sale schedules use Eastern time; return null for missing dates so callers can supply their own label.
export const formatEasternDate = (value, includeTime = false) => {
  if (!value || !Number.isFinite(Date.parse(value))) return null;
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...(includeTime && { hour: 'numeric', minute: '2-digit' })
  }).format(new Date(value));
};

export const stringToReadableDate = ({ day = '01', month = '01', year = '2000', date, week }) => {
  const full_date = date ? moment(date) : moment(`${year}-${month}-${day}`);
  week && full_date.week(week);

  const [month_string, day_string] = full_date.format('MMMM dddd YYYY').split(' ');
  const [shortened_month_string] = full_date.format('MMM DD YYYY').split(' ');

  return {
    month: month_string,
    shortened_month: shortened_month_string,
    day_number: full_date.day(),
    day_of_week: day_string,
    day_of_month: full_date.date(),
    year,
    dayOfWeek: full_date.weekday,
    weekOfYear: full_date.weekYear,
    numDaysInMonth: full_date.daysInMonth
  };
};

// Must be a valid domain like "example.com" or "sub.example.co.uk" excluding "www." and any paths or protocols.
export const isValidDomain = domain => {
  if (!domain || typeof domain !== 'string') return false;

  const hasHttp = domain.includes('http://') || domain.includes('https://');
  if (hasHttp) return false;

  const hasWWW = /^www\./.test(domain);
  if (hasWWW) return false;

  const domainPattern = /^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/;
  return domainPattern.test(domain);
};

export const isValidBrandDomainKey = value => {
  if (!value || typeof value !== 'string') return false;
  const [hostname] = value.split('/');
  if (!isValidDomain(hostname)) return false;
  return getDomain(`https://${value}`) === value;
};
